// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Ztl8","footer":"ChangeClinic_footer__3m-ZG"};